export default {
  title: 'Add card',
  buttons: {
    save: 'Save',
  },
  feedback: {
    success: 'Card saved successfully',
  },
};
